import { OsTextFieldVersion } from 'opensolar-ui/src/core'
import { useComponentVersion } from 'opensolar-ui/src/hooks'
import { ChipsInputV2 } from './ChipsInputV2'
import { ChipsInputProps, ChipsInputV3 } from './ChipsInputV3'

export const ChipsInput = <Item, Value>(props: ChipsInputProps<Item, Value>) => {
  let version = useComponentVersion('text_field') // Using text_field here as ChipsInput isn't an 'official' low-level component
  switch (version) {
    case OsTextFieldVersion.V2:
      return <ChipsInputV3 {...props} />
    default:
      return <ChipsInputV2 {...props} />
  }
}
